import { Injectable } from '@angular/core';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';

// angular-auth-oidc-client 14 defaults to sessionStorage; the app always kept the OIDC state in
// localStorage (AuthenticationService.clearLocalTokens() removes it from there), so keep that.
@Injectable({ providedIn: 'root' })
export class OidcLocalStorageService implements AbstractSecurityStorage {
    read(key: string): any {
        return localStorage.getItem(key);
    }

    write(key: string, value: any): void {
        localStorage.setItem(key, value);
    }

    remove(key: string): void {
        localStorage.removeItem(key);
    }

    clear(): void {
        localStorage.clear();
    }
}
